<template>
  <el-cascader
    class="w-200 mr-12"
    v-model="jobIds"
    :options="jobOptions"
    :props="jobProps"
    :size="size"
    :placeholder="placeholder"
    clearable
    @change="handleChange"
    :disabled="disabled"
    ref="cascader"
  ></el-cascader>
</template>

<script type="text/javascript">
import kcellService from "@/global/service/kcell";

export default {
  props: {
    size: {
      type: String,
      default: "mini"
    },
    jobId: {
      type: [Number, Array],
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请选择选题方向"
    },
    emitPath: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  watch: {
    jobId: {
      handler(val) {
        this.jobIds = val;
      },
      immediate: true
    }
  },
  data() {
    return {
      jobIds: null,
      jobOptions: [],
      jobProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: this.multiple,
        emitPath: this.emitPath
      }
    };
  },
  created() {
    this.getJobOptions();
  },
  methods: {
    getJobOptions() {
      // 因为岗位多个层级的子节点集不一样有 job_categories、jobs、children ，这里统一专为 children 。
      // 又因为岗位多个层级的 id 会有重叠且不支持 uuid 穿参数，所以要使用数组形式取最后一个值。
      // 同时判断做默认展示
      kcellService.kcellPositionsAll().then(res => {
        this.jobOptions = res.map(industry => {
          industry.children = industry.job_categories;
          delete industry.job_categories;
          industry.children.forEach(category => {
            category.children = category.jobs;
            delete category.jobs;
            category.children.forEach(group => {
              group.children.forEach(job => {
                job.disabled = !job.has_skill_model;
                if (this.jobId && this.jobId === job.id) {
                  this.jobIds = [industry.id, category.id, group.id, job.id];
                }
              });
            });
          });
          return industry;
        });
      });
    },
    handleChange(e) {
      if (this.emitPath) {
        e = e[e.length - 1];
      }
      let result;
      if (!this.multiple) {
        result = this.$refs.cascader.getCheckedNodes();
      } else {
        result = this.$refs.cascader.getCheckedNodes().filter(data => {
          return e.indexOf(data.value) >= 0;
        });
      }
      this.$emit("getNodes", result);
    }
  }
};
</script>
